import { useReducer } from "react";
import api from '../../../api/resources';

const intialState = {
  referenceTypes: []
};

function reducer(state, action) {
  switch (action.type) {
    case "REFERENCE_TYPES":
      return {
        ...state,
        referenceTypes: action.referenceTypes
      };
    default:
      return {
        ...state
      };
  }
}

export default function useResourceForm() {
  const [dataSources, dispatch] = useReducer(reducer, intialState);

  function getReferenceTypes() {
    api.getReferenceTypes().then(({ data }) => {
      dispatch({ type: "REFERENCE_TYPES", referenceTypes: data });
    });
  }

  return {
    dataSources,
    getReferenceTypes
  };
}
